import { TOOL_NAMES } from './TOOL_NAMES';

export const TOOL_NAME_VALUES: 'IssueSearchTool'[] = Object.values(TOOL_NAMES);
